import { trpc } from '@/client/utils/trpc';
import { ProjectRow } from './ProjectRow';
import type { RouterOutputs } from '@/client/utils/trpc';

type Employee = RouterOutputs['employees']['list'][number];

interface PersonProjectsTabProps {
  person: Employee;
}

export function PersonProjectsTab({ person }: PersonProjectsTabProps) {
  const { data: projects = [], isLoading } = trpc.employees.getProjects.useQuery(
    { id: person.id },
    { enabled: !!person.id },
  );

  if (isLoading) {
    return (
      <div className="rounded-lg border p-8 text-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <p className="rounded-lg border p-8 text-center text-sm text-muted-foreground">
        No projects assigned.
      </p>
    );
  }

  return (
    <div className="rounded-lg border">
      {projects.map((p, i) => (
        <ProjectRow key={p.id} project={p} isLast={i === projects.length - 1} />
      ))}
    </div>
  );
}
